// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk } from 'types';

export type EntryType = 'topic' | 'survey' | 'appointment';

export const ADD_IMAGE = 'ADD_IMAGE';
export const addImage = (
  entryType: EntryType,
  id: string,
  image: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: ADD_IMAGE,
    url: '/api/management/image',
    method: 'post',
    body: {
      entryType,
      id,
      image,
    },
    dispatch,
  });

export const DELETE_IMAGE = 'DELETE_IMAGE';
export const deleteImage = (
  entryType: EntryType,
  id: string,
  index: number
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: DELETE_IMAGE,
    url: `/api/management/image/delete`,
    method: 'post',
    body: {
      entryType,
      id,
      index,
    },
    dispatch,
  });



// WEBPACK FOOTER //
// ./src/redux/actions/images.js